import * as Dialog from "@radix-ui/react-dialog";
import { TbX, TbInfoCircle } from "react-icons/tb";
import { getVersionInfo } from "@/lib/version";

interface AboutModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AboutModal: React.FC<AboutModalProps> = ({
  open,
  onOpenChange,
}) => {
  const versionInfo = getVersionInfo();

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-gray-800/50 z-[1100]" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-full max-w-md z-[1101]">
          <div className="flex flex-col gap-6 items-start justify-start p-6 w-full">
            {/* Header */}
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                  <TbInfoCircle size={20} className="text-blue-600" />
                </div>
                <Dialog.Title className="font-['Open_Sans'] font-bold text-[#444444] text-[18px]">
                  About Taskr
                </Dialog.Title>
              </div>
              <Dialog.Close asChild>
                <button className="cursor-pointer w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
                  <TbX size={16} className="text-gray-500" />
                </button>
              </Dialog.Close>
            </div>

            {/* Content */}
            <div className="flex flex-col gap-4 w-full">
              {/* Logo and App Name */}
              <div className="flex flex-col items-center gap-4 py-4">
                <div
                  className="w-16 h-16 bg-no-repeat bg-center bg-contain"
                  style={{
                    backgroundImage: `url('images/logo.svg')`,
                  }}
                />
                <div className="text-center">
                  <h2 className="font-['Open_Sans'] font-bold text-[24px] text-[#444444]">
                    Taskr
                  </h2>
                  <p className="text-[#828282] text-[14px] mt-1">
                    Task Management & Asset Tracking System
                  </p>
                </div>
              </div>

              {/* Last Build */}
              <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                <h3 className="font-['Open_Sans'] font-semibold text-[14px] text-[#444444] mb-2">
                  Last Build
                </h3>
                <div className="space-y-2 text-[12px]">
                  <div className="flex justify-between">
                    <span className="text-[#828282]">Version:</span>
                    <span className="font-medium text-[#444444]">
                      v{versionInfo.version}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-[#828282]">Built:</span>
                    <span className="font-medium text-[#444444]">
                      {versionInfo.buildDateTime}
                    </span>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="text-center text-[11px] text-[#828282] pt-2">
                © 2025 Taskr. All rights reserved.
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
